import { motion } from "framer-motion";
import { Smartphone, Laptop, Monitor } from "lucide-react";

const devices = [
  { icon: Smartphone, title: "HP", desc: "Edit di mana aja langsung dari genggaman." },
  { icon: Laptop, title: "Laptop", desc: "Workflow lebih leluasa dengan layar lebar." },
  { icon: Monitor, title: "PC", desc: "Performa maksimal untuk project berat." },
];

export const CapCutDevices = () => (
  <section className="py-24 bg-white" id="capcut-devices">
    <div className="max-w-5xl mx-auto px-6 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="text-center mb-14"
      >
        <h2 className="font-capcut-heading text-3xl sm:text-4xl lg:text-5xl font-black tracking-tight text-slate-900">
          Satu akun, jalan di <span className="text-blue-600">semua perangkat</span>.
        </h2>
        <p className="mt-4 text-slate-600 text-base md:text-lg">
          Login di HP, Laptop, atau PC — pilih 1 perangkat favoritmu dan langsung gas edit.
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {devices.map(({ icon: Icon, title, desc }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.55, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
            className="rounded-2xl bg-white border border-slate-200 p-8 text-center shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_40px_rgb(37,99,235,0.1)] hover:-translate-y-1.5 transition-[transform,box-shadow] duration-300"
            data-testid={`capcut-device-${i}`}
          >
            <span className="inline-flex w-14 h-14 rounded-2xl bg-blue-50 items-center justify-center">
              <Icon className="w-7 h-7 text-blue-600" strokeWidth={2} />
            </span>
            <h3 className="mt-5 font-capcut-heading text-xl font-bold text-slate-900">{title}</h3>
            <p className="mt-2 text-sm text-slate-500 leading-relaxed">{desc}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
